






















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import MultiComponent from '@/components/Controls/MultiComponent.vue';


@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError', 'souffling_list', 'plan_list', 'schemas'
    ]),
    ...mapState('ubic', [
      'token'
    ]),
    ...mapGetters(STORE_KEY, [
    ]),
  },
  components: {
    MultiComponent
  }
})
export default class ShiftAtomSoufflingBottling extends Vue {

  @Prop() documentId!: string;
  @Prop() lineId!: string;
  @Prop() type!: string;

  opened: any[] = [];
  public dropFiles = [];
  public is_processing = true;

  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`)
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
      lineId: this.lineId,
      type: this.type,
    }).then(() => {
      this.is_processing = false;
    });
  }

  public setAccepted(item: any, plan: any) {
    this.$store.dispatch(`${STORE_KEY}/setAccepted`, {
      documentId: this.documentId,
      item, plan
    }).then(() => {
      this.handleParamsChange()
    });
  }

  public setDone(item: any) {
    this.$store.dispatch(`${STORE_KEY}/setDone`, {
      plan: item
    }).then(() => {
      this.handleParamsChange()
    });
  }

  public setValue(plan_id: any, index: any, value: any) {
    console.log('setValue', plan_id, index, value)
    this.$store.dispatch(`${STORE_KEY}/setItemValue`, {
      plan_id, index, newValue: value
    })
  }
}

